import React from 'react';
import Masonry from 'react-masonry-css';
import { BREAKPOINT_COLS } from './MasonryAccordionLinks.constants';
import { getDelay } from './MasonryAccordionLinks.utils';
import useResponsive from '../../../../../../../../hooks/use-responsive/use-responsive';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import SlideReveal from '../../../../../../../animations/components/Reveal/variants/SlideReveal/SlideReveal';
import { generateKey } from '../../../Links/Links.utils';
import AccordionLinks from '../AccordionLinks';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import { ACCORDION_REVEAL_ANIMATION_DURATION } from '../PopupContent/PopupContent.constants';
var defaultProps = {
  onMouseEnter: function onMouseEnter() {
    return null;
  },
  onMouseLeave: function onMouseLeave() {
    return null;
  },
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: [],
  onLinkClick: function onLinkClick() {
    return null;
  }
};
export default function MasonryAccordionLinks(_ref) {
  var links = _ref.links,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices,
    onLinkClick = _ref.onLinkClick;
  var _useResponsive = useResponsive(),
    isDesktop = _useResponsive.isDesktop;
  return /*#__PURE__*/React.createElement(Masonry, {
    className: "ui grid stacking doubling popup-content masonry",
    breakpointCols: BREAKPOINT_COLS,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    columnClassName: "column"
  }, links.map(function (link, index) {
    var title = link.title,
      url = link.url,
      slug = link.slug;
    var key = generateKey(title, url, slug);
    var delay = getDelay(index, isDesktop);
    return /*#__PURE__*/React.createElement(SlideReveal, {
      className: "content",
      direction: "down",
      duration: ACCORDION_REVEAL_ANIMATION_DURATION,
      delay: delay,
      fade: true,
      distance: "16px",
      key: key,
      triggerOnce: true
    }, /*#__PURE__*/React.createElement(AccordionLinks, {
      link: link,
      maxLinksToShow: maxLinksToShow,
      onLinkClick: onLinkClick,
      initialActive: initialActiveIndices.includes(index)
    }));
  }));
}
MasonryAccordionLinks.defaultProps = defaultProps;